import {
  FETCH_ALL_BILL_PRODUCTS,
  RESET_BILL_PRODUCTS,
  REMOVE_BILL_PRODUCT,
  ADD_BILL_PRODUCT,
  UPDATE_BILL_PRODUCT,
} from './../../mutation-types';

export default {
  [RESET_BILL_PRODUCTS](state) {
    state.all = [];
  },

  [FETCH_ALL_BILL_PRODUCTS](state, billProducts) {
    state.all = billProducts;
  },

  [REMOVE_BILL_PRODUCT](state, id) {
    state.all = state.all.filter(p => p.id !== id);
  },

  [ADD_BILL_PRODUCT](state, billProduct) {
    state.all.push(billProduct);
  },

  [UPDATE_BILL_PRODUCT](state, { billProduct, id }) {
    state.all.map((p) => {
      if (p.id.toString() === id.toString()) {
        Object.keys(billProduct).map((k) => {
          p[k] = billProduct[k];
          return k;
        });
      }
      return p;
    });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/billProduct/mutations.js